import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "components/userportal/AddAdmin.module.scss";
import {
  getRequestInAssets as getRequest,
  postRequestInAssets as postRequest,
  putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import { useHistory } from "react-router-dom";
import Header from "components/Header";
import Master from "screen/Master";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import notificationService from "services/notification.service";
import { Tooltip } from "antd";
import ReactTooltip from "react-tooltip";
import QRCodeView from "../../components/QRcode/QRCode";

var nav = {
  site: "user-name",
  pageGroups: [
    {
      pageGroupName: "Page Group",
      pageLinks: [
        {
          pageName: "PageLinks1",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
        {
          pageName: "PageLinks2",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
        {
          pageName: "PageLinks3",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
      ],
    },
    {
      pageGroupName: "Page Group",
      pageLinks: [
        {
          pageName: "PageLinks1",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
        {
          pageName: "PageLinks2",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
        {
          pageName: "PageLinks3",
          img: require("assets/185cc62ad0fb618d8158311bfa949257.png").default,
        },
      ],
    },
  ],
};

var nav_1 = {
  site: "Alexander Hipp",
  pageGroups: [
    {
      pageName: "Enterprise",
      img: require("assets/enter 1.png").default,
    },
    {
      pageName: "Assets",
      img: require("assets/Vector (6).png").default,
    },
    {
      pageName: "User",
      img: require("assets/Vector (6).png").default,
    },
    {
      pageName: "FOTA",
      img: require("assets/Vector (5).png").default,
    },
  ],
};

var id = undefined;
var action = null;
var title = "Add Swap Station";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var fileName = "";
var tempExt = "";
var trimeFileName = "";
var fileIndexValue = "";

function AddSwapStationForm(props) {
  const initialFormValues = {
    name: "",
    siteId: "",
    make: "",
    model: "",
    voltage: "",
    numOfSlots: "",
    power: "",
    fileLocation: "",
    batteryModel: "",
    batteryModelId: -1,
    batteryMake: "",
    batteryMakeId: -1,
    rfid: true,
    isActive: true,
    makeId: -1,
    modelId: -1,
    status: "",
    specFileActive: true,
    specFilePathError: "",
    fileExt: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [sitesList, setSitesList] = useState([]);
  const [slotsList, setSlotsList] = useState([]);
  const [makestationList, setMakeStationList] = useState([]);
  const [sitesListLastest, setSitesListLastest] = useState([]);
  const [modelYearList, setModelYearList] = useState([]);
  const [makeList, setMakeList] = useState([]);
  const [swapModel, setSwapModel] = useState([]);
  const [file, setFile] = useState(null);
  const [enterpriseName, setEnterpriseName] = useState([]);
  const [choosenFileName, setChoosenFileName] = useState("No file Choosen");
  const [toggleRemoveBtn, setToggleRemoveBtn] = useState(true);

  const [makeName, setMakeName] = useState("");
  const [tempChoosenFileName, setTempChoosenFileName] =
    useState("No file Choosen");

  const history = useHistory();

  const getSwapStationsDataByID = async (id) => {
    fileName = "";
    tempExt = "";
    trimeFileName = "";
    fileIndexValue = "";

    await getRequest("bss/swappingStation/getSwappingStation/" + id)
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data);
          var fileUploadNameArr = res?.data?.specFilePath?.split("/");
          const arrCount = fileUploadNameArr?.length;
          setFile(res?.data?.specFilePath);

          const findFileExtIndexHandle = (extIndex) => {
            if (extIndex === ".pdf")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".pdf"));
            if (extIndex === ".jpg")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".jpg"));
                if (extIndex === ".jpeg")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".jpeg"));
            if (extIndex === ".png")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".png"));
            if (extIndex === ".PDF")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".PDF"));
            if (extIndex === ".JPG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".JPG"));
                if (extIndex === ".JPEG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".JPEG"));
            if (extIndex === ".PNG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".PNG"));
          };

          const trimeFileNameHandle = (extType) => {
            if (extType === ".pdf")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".pdf")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".jpg")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".jpg")),
                findFileExtIndexHandle(extType)
              );
              if (extType === ".jpeg")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".jpeg")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".png")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".png")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".pdf")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".pdf")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".PDF")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".PDF")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".JPG")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".JPG")),
                findFileExtIndexHandle(extType)
              );
              if (extType === ".JPEG")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".JPEG")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".PNG")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".PNG")),
                findFileExtIndexHandle(extType)
              );
          };

          const result = () => {
            if (fileUploadNameArr[arrCount - 1].includes(".pdf"))
              return (tempExt = ".pdf"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".jpg"))
              return (tempExt = ".jpg"), trimeFileNameHandle(tempExt);
              if (fileUploadNameArr[arrCount - 1].includes(".jpeg"))
              return (tempExt = ".jpeg"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".png"))
              return (tempExt = ".png"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".pdf"))
              return (tempExt = ".pdf"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".PDF"))
              return (tempExt = ".PDF"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".JPG"))
              return (tempExt = ".JPG"), trimeFileNameHandle(tempExt);
              if (fileUploadNameArr[arrCount - 1].includes(".JPEG"))
              return (tempExt = ".JPEG"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".PNG"))
              return (tempExt = ".PNG"), trimeFileNameHandle(tempExt);
          };

          result();

          const shortFileName = trimeFileName && trimeFileName[0].slice(0, 10);

          const fileExt = fileUploadNameArr[arrCount - 1].slice(fileIndexValue);
          setChoosenFileName(
            shortFileName.length > 0
              ? shortFileName + fileExt
              : "No file Choosen"
          );
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const getSite = useCallback(async () => {
    await getRequest(`bss/siteInfo`)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setSitesListLastest(res.data.sites);
          //props.assetCount(()=>res.data.count);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSite();
  }, []);

  const getStationMakes = useCallback(async (string) => {
    await getRequest("make/getAll?type=SWAPSTATION")
      .then((res) => {
        if (res.data != null) {
          setMakeStationList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getStationMakes();
  }, []);

  const getMakes = useCallback(async (string) => {
    await getRequest("make/getAll?type=BATTERY")
      .then((res) => {
        if (res.data != null) {
          setMakeList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getMakes();
  }, []);

  const getModels = useCallback(async (id) => {
    await getRequest("model/getAll?makeId=" + id)
      .then((res) => {
        if (res && res.data) {
          setModelYearList(res.data);
        }
        if (res.data.length == 0) {
          setFormValues((data) => ({
            ...data,
            batteryModelId: -1,
          }));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSwapModels = useCallback(async (id) => {
    await getRequest("model/getAll?makeId=" + id)
      .then((res) => {
        if (res && res.data) {
          setSwapModel(res.data);
        }
        if (res.data.length == 0) {
          setFormValues((data) => ({
            ...data,
            modelId: -1,
          }));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Assets",
      state: { table: 2, compomentRenderType: "view" },
    });
  };

  const getSites = useCallback(async (string) => {
    await getRequest("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSlots = useCallback(async (string) => {
    await getRequest("bss/swappingStation/getSlots")
      .then((res) => {
        if (res.data != null) {
          setSlotsList(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSites();
    getSlots();

    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Swap Station";
      readOnlyField = true;
      onlyView = false;
      getSwapStationsDataByID(id);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Swap Station";
      onlyView = true;
      getSwapStationsDataByID(id);
    } else {
      onlyView = false;
      readOnlyField = false;
      title = "Add Swap Station";
      action = "Submit";
    }
  }, []);

  const patchForm = (data) => {
    data.fileLocation = data.fileLocation === "" ? null : data.fileLocation;
    data.specFilePath = data.specFilePath === null ? "" : data.specFilePath;
    if (data?.makeId) {
      getSwapModels(data?.makeId);
    }
    if (data?.batteryMakeId) {
      getModels(data?.batteryMakeId);
    }
    setTempChoosenFileName(data.specFilePath);
    setFormValues({
      name: data.name,
      siteId: data.siteId,
      make: data.make,
      model: data.model,
      voltage: data.voltage,
      numOfSlots: data.numOfSlots,
      power: data.power,
      batteryModelId: data.batteryModelId,
      batteryModel: data.batteryModel,
      batteryMake: data.batteryMake,
      isActive: data.isActive,
      rfid: data.rfid,
      id: Number(id),
      batteryMakeId: data.batteryMakeId,
      makeId: data.makeId,
      modelId: data.modelId,
      status: data.status,
      enterprise: data.enterprise,
      specFilePath: data.specFilePath,
      fileExt: data?.specFilePath.substring(
        data?.specFilePath.indexOf(".") + 1
      ),
    });
    setEnterpriseName(data.enterprise);
    // var fileName = data.specFilePath;
    // fileName = fileName.slice(0, 25);
    // setChoosenFileName(fileName);
  };

  const removeUploadFile = (e) => {
    e.stopPropagation();
    fileName = "";
    setTempChoosenFileName(() => "No file Choosen");
    setFormValues({
      ...formValues,
      ["specFilePath"]: "",
      ["fileExt"]: "",
    });
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      var size = parseFloat(img.size / (1024 * 1024)).toFixed(2);
      if (size > 3) {
        notificationService.showNonBlacklistedError(
          "",
          "Please select image size less than 3 MB."
        );
        return false;
      }

      // initialFormValues.fileLocation = URL.createObjectURL(img);
      const fileExtension = img.name.split(".").at(-1);
      const allowedFileTypes = ["jpg","jpeg", "png", "pdf", "PDF", "JPG", "JPEG", "PNG"];
      setTempChoosenFileName(img.name);
      setChoosenFileName(img.name);
      setFile(img);
      if (!allowedFileTypes.includes(fileExtension)) {
        setFormValues({ ...formValues, specFileActive: false });
      } else {
        setFormValues({ ...formValues, specFileActive: true });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setFormValues({ ...formValues, [name]: value });
    if (name === "rfid")
      setFormValues({ ...formValues, [name]: value === "true" ? true : false });

    if (name === "batteryMakeId") {
      getModels(value);
      formValues.batteryMakeId = value;
      setFormValues({ ...formValues, batteryModelId: "" });
      makeList.find((data) => {
        if (data.id == value) {
          formValues.batteryMake = data.name;
          setMakeName(data.name);
        }
      });
    }
    if (name === "voltage") {
      setFormValues({
        ...formValues,
        ["voltage"]: numericValue,
      });
    }
    if (name === "power") {
      setFormValues({
        ...formValues,
        ["power"]: numericValue,
      });
    }

    if (name === "batteryModelId") {
      setFormValues({
        ...formValues,
        batteryModelId: Number(value),
        batteryModel: "",
      });

      modelYearList.find((data) => {
        if (data.id == value) {
          formValues.batteryModelId = data.id;
          setFormValues({
            ...formValues,
            batteryModel: data.name,
            batteryModelId: Number(data.id),
          });
        }
      });
    }

    if (name === "makeId") {
      getSwapModels(value);
      formValues.makeId = value;
      setFormValues({ ...formValues, modelId: "" });
      makestationList.find((data) => {
        if (data.id == value) {
          formValues.make = data.name;
          setMakeName(data.name);
        }
      });
    }

    if (name === "modelId") {
      setFormValues({
        ...formValues,
        modelId: Number(value),
        model: "",
      });

      swapModel.find((data) => {
        if (data.id == value) {
          formValues.modelId = data.id;
          setFormValues({
            ...formValues,
            model: data.name,
            modelId: Number(data.id),
          });
        }
      });
    }

    if (name === "siteId") {
      var st = sitesListLastest.find((x) => {
        return value == x.siteId;
      });
      setEnterpriseName(st.enterprise);
    }
  };

  const downloadFile = useCallback(async (enterprise, filePath) => {
    if (!onlyView) {
      return;
    }
    await getRequestInFileDownload(
      `downloadFile/${formValues.enterprise}?fileName=${encodeURIComponent(
        formValues.specFilePath
      )}`
    ).then((res) => {
      if (res) {
        downloadPDF(res);
      }
    });
  });

  function downloadPDF(pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = formValues.name + "." + formValues?.fileExt;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues, file);
    if (Object.values(result).every((x) => x === "")) {
      if (action === "Update") {
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append(
            "data",
            JSON.stringify({
              swappingStation: formValues,
              siteEnterprise: enterpriseName,
            })
          );
          putRequest("bss/swappingStation/updateSwappingStation", formData)
            .then((res) => {
              if (res && res?.data) {
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                history.push({
                  pathname: "/Assets",
                  state: { table: 2, compomentRenderType: "view" },
                });
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
            });
        } catch (error) {
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.response?.data?.message
          );
          console.log(error);
        }
      } else {
        if (
          formValues.status === "FAULT" ||
          formValues.status === "UNDERMAINTENANCE"
        )
          formValues.isActive = false;
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append(
            "data",
            JSON.stringify({
              swappingStation: formValues,
              siteEnterprise: enterpriseName,
            })
          );

          postRequest("bss/swappingStation/addSwappingStation", formData)
            .then((res) => {
              if (res && res?.data) {
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                history.push({
                  pathname: "/Assets",
                  state: { table: 2 },
                });
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
            });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};
    if (formValues.specFileActive === false) {
      errors.specFilePathError = "jpg, jpeg, png, pdf are the only allowed file type";
    } else {
      errors.specFilePathError = "";
    }

    // '^[A-Za-z0-9 ]*$'
    if (!formValues.name) {
      errors.name = "Swap Station is required!";
    } else if (!/^[ A-Za-z0-9-_./&']*$/i.test(formValues.name)) {
      errors.name = "/-_&. are the only allowed special characters!";
    } else if (formValues.name.trim() === "") {
      errors.name = "Swap Station is not valid";
    } else {
      errors.name = "";
    }

    if (!formValues.siteId || formValues.siteId === "-1") {
      errors.siteId = "Site Name is required!";
    } else {
      errors.siteId = "";
    }

    if (!formValues.numOfSlots || formValues.numOfSlots === "-1") {
      errors.numOfSlots = "Number of slots is required!";
    } else {
      errors.numOfSlots = "";
    }

    if (!formValues.makeId || formValues.makeId == -1) {
      errors.make = "Swap Station Make is required!";
    } else {
      errors.make = "";
    }

    if (!formValues.modelId || formValues.modelId == -1) {
      errors.model = "Swap Station Model is required!";
    } else {
      errors.model = "";
    }

    if (!formValues.voltage) {
      errors.voltage = "Voltage is required!";
    } else if (!/^[a-z0-9]+$/i.test(formValues.voltage)) {
      errors.voltage = "Voltage should be only alpha numeric value.";
    } else {
      errors.voltage = "";
    }

    if (!formValues.power) {
      errors.power = "Power is required!";
    } else if (!/^[a-z0-9]+$/i.test(formValues.power)) {
      errors.power = "Power should be only alpha numeric value.";
    } else {
      errors.power = "";
    }

    if (!formValues.batteryModelId || formValues.batteryModelId == -1) {
      errors.batteryModel = "Battery Model is required!";
    } else {
      errors.batteryModel = "";
    }

    if (!formValues.batteryMakeId || formValues.batteryMakeId == -1) {
      errors.batteryMake = "Battery Make is required!";
    } else {
      errors.batteryMake = "";
    }

    if (!formValues.status || formValues.status === "-1") {
      errors.status = "Swap Station Status is required!";
    } else {
      errors.status = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  return (
    <div
      id="AddSwapStation_block"
      className={`AddEnterprise${cn(styles.block, styles.block_layout)}`}
    >
      <div
        id="AddSwapStation_block_layout"
        className={cn(styles.flex, styles.flex_layout)}
      >
        <div className={cn(styles.flex_spacer)} />
        <div id="AddSwapStation_block_layout1" className={cn(styles.flex_item1)}>
          <div
            id="AddSwapStation_block_layout2"
            className={cn(styles.flex1, styles.flex1_layout)}
          >
            <h2
              id="AddSwapStation_Heading"
              className={cn(styles.medium_title, styles.medium_title_layout)}
            >
              {"Swap Station"}
            </h2>
            <div
              id="AddSwapStation_Form_layout"
              className={cn(styles.group, styles.group_layout)}
            >
              <form id="AddSwapStation_Form">
                <div
                  id="AddSwapStation_Form_layout"
                  className={cn(styles.flex3, styles.flex3_layout)}
                >
                  <h3
                    id="AddSwapStation_Form_Title"
                    className={cn(styles.subtitle, styles.subtitle_layout)}
                  >
                    {title}
                  </h3>
                  <hr className={cn(styles.line, styles.line_layout)} />

                  <div
                    id="AddSwapStation_Form_row1"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_SwapStation"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_SwapStation_block"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_SwapStation_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Swap Station*"}
                        </div>

                        <input
                          id="AddSwapStation_SwapStation_input"
                          type="text"
                          name="name"
                          className={cn(styles.line1, styles.line1_layout)}
                          value={formValues.name}
                          onChange={handleChange}
                          disabled={onlyView}
                          maxLength="50"
                          pattern="^[a-zA-Z0-9 ]+$"
                        />
                      </div>
                      <p>{formErrors.name}</p>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_Site_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_Site"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_Site_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Site*"}
                        </div>

                        <select
                          id="AddSwapStation_Site_Select"
                          name="siteId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.siteId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Site</option>
                          {sitesListLastest.map((obj) => {
                            return (
                              <option value={obj.siteId}>{obj.siteName}</option>
                            );
                          })}
                        </select>
                      </div>
                      <p>{formErrors.siteId}</p>
                    </div>
                  </div>

                  <div
                    id="AddSwapStation_Form_row2"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_NumOfSlots_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_NumOfSlots"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_NumOfSlots_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"No. of Slots*"}
                        </div>
                        <select
                          id="AddSwapStation_NumOfSlots_Select"
                          name="numOfSlots"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.numOfSlots}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Slots</option>
                          {/* <option value="1">1</option> */}
                          {slotsList.map((val) => {
                            return <option value={val}>{val}</option>;
                          })}
                        </select>
                      </div>
                      <p>{formErrors.numOfSlots}</p>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_Power_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_Power"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_Power_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Power (kWh)*"}
                        </div>
                        <input
                          id="AddSwapStation_Power_input"
                          type="text"
                          name="power"
                          maxlength="4"
                          className={cn(styles.line1, styles.line1_layout)}
                          value={formValues.power}
                          onChange={handleChange}
                          disabled={onlyView}
                        />
                      </div>
                      <p>{formErrors.power}</p>
                    </div>
                  </div>

                  <div
                    id="AddSwapStation_Form_row3"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_Voltage_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_Voltage"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_Voltage_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Voltage (V)*"}
                        </div>
                        <input
                          id="AddSwapStation_Voltage_input"
                          type="text"
                          name="voltage"
                          maxlength="3"
                          className={cn(styles.line1, styles.line1_layout)}
                          value={formValues.voltage}
                          onChange={handleChange}
                          disabled={onlyView}
                        />
                      </div>
                      <p>{formErrors.voltage}</p>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_Rfid_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_Rfid"
                        className={cn(styles.block3, styles.block3_layout)}
                        onChange={handleChange}
                      >
                        <div
                          id="AddSwapStation_Rfid_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"RFID*"}
                          <div className={cn(styles.flex2_spacer)} />
                          <input
                            id="AddSwapStation_Rfid_input1"
                            type="radio"
                            name="rfid"
                            value={true}
                            onChange={handleChange}
                            checked={formValues.rfid === true ? true : false}
                            disabled={onlyView}
                          />{" "}
                          <span style={{ marginRight: 10 }}>Yes</span>
                          <input
                            id="AddSwapStation_Rfid_input2"
                            type="radio"
                            name="rfid"
                            value={false}
                            onChange={handleChange}
                            checked={formValues.rfid === false ? true : false}
                            disabled={onlyView}
                          />{" "}
                          No
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    id="AddSwapStation_Form_row4"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_SwapStationMake_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_SwapStationMake"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_SwapStationMake_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Swap Station Make*"}
                        </div>
                        {/* <input type="text" name="make" className={cn(styles.line1, styles.line1_layout)} value={formValues.make} onChange={handleChange} disabled={onlyView} /> */}
                        <select
                          id="AddSwapStation_SwapStationMake_select"
                          name="makeId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.makeId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Swap Station Make</option>
                          {/* <option value="1">1</option> */}
                          {makestationList.map((val) => {
                            return <option value={val.id}>{val.name}</option>;
                          })}
                        </select>
                      </div>
                      <p>{formErrors.make}</p>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_SwapStationModel_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_SwapStationModel"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_SwapStationModel_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Swap Station Model*"}
                        </div>
                        {/* <input type="text" name="model" className={cn(styles.line1, styles.line1_layout)} value={formValues.model} onChange={handleChange}  disabled={onlyView} /> */}
                        <select
                          id="AddSwapStation_SwapStationModel_select"
                          name="modelId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.modelId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Swap Station Model</option>
                          {/* <option value="1">1</option> */}
                          {swapModel.map((val) => {
                            return <option value={val.id}>{val.name}</option>;
                          })}
                        </select>
                      </div>
                      <p>{formErrors.model}</p>
                    </div>
                  </div>

                  <div
                    id="AddSwapStation_Form_row5"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_UploadDownLoad_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_UploadDownLoad_file"
                        className={cn(
                          styles.block3,
                          styles.block3_layout,
                          styles.newBlock,
                          styles.upload_Fild
                        )}
                        onClick={downloadFile}
                      >
                        <input
                          type="file"
                          name="fileLocation"
                          id="img"
                          accept="image/png, image/jpeg, application/pdf"
                          //,application/vnd.ms-excel
                          onChange={onImageChange}
                          style={{ display: "none", width: "40%" }}
                          disabled={onlyView}
                          onClick={(event) => {
                            const { target = {} } = event || {};
                            target.value = "";
                          }}
                        />

                        <div
                          data-for="main"
                          data-tip={tempChoosenFileName}
                          style={
                            choosenFileName == "No file Choosen" && onlyView
                              ? {
                                  height: "30px",
                                  width: "50%",
                                  float: "left",
                                  display: "flex",
                                  alignItems: "center",
                                }
                              : {
                                  height: "30px",
                                  width: "50%",
                                  float: "left",
                                  display: "flex",
                                  alignItems: "center",
                                }
                          }
                        >
                          {choosenFileName === "No file Choosen" && onlyView
                            ? "No file Choosen"
                            : choosenFileName}
                        </div>
                        <div
                          id="AddSwapStation_UploadDownLoad_button"
                          className={cn(styles.upload_right_side_btn_container)}
                        >
                          <label
                            className={cn(styles.remove_Fild_btn)}
                            style={{
                              display:
                                toggleRemoveBtn === false
                                  ? "none"
                                  : choosenFileName === "No file Choosen"
                                  ? "none"
                                  : choosenFileName === "" && onlyView
                                  ? "none"
                                  : !onlyView &&
                                    choosenFileName.length !== "No file Choosen"
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "28px",
                              width: "33px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              setChoosenFileName(() => "No file Choosen");
                              removeUploadFile(e);
                              setToggleRemoveBtn(false);
                            }}
                          >
                            X
                          </label>

                          <label
                            for="img"
                            style={{
                              display:
                                onlyView &&
                                choosenFileName !== "No file Choosen"
                                  ? "flex"
                                  : !onlyView
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                              alignItems: "center",
                              marginRight: "20px",
                              border: "none",
                              backgroundColor: "#23297a",
                              color: "white",
                              height: "28px",
                              padding: "6px 15px",
                              width: "120px",
                              float: "right",
                              textAlign: "center",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              setToggleRemoveBtn(true);
                            }}
                          >
                            {onlyView && choosenFileName !== "No file Choosen"
                              ? "Download"
                              : !onlyView
                              ? "Upload File"
                              : ""}
                          </label>
                        </div>
                      </div>
                      <p>{formErrors.specFilePathError}</p>
                    </div>

                    <ReactTooltip id="main" type="dark" />

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_BatteryMake_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          id="AddSwapStation_BatteryMake_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Battery Make*"}
                        </div>
                        {/* <input type="text" name="batteryMake" className={cn(styles.line1, styles.line1_layout)} value={formValues.batteryMake} onChange={handleChange} disabled={onlyView}/> */}
                        <select
                          id="AddSwapStation_BatteryMake_select"
                          name="batteryMakeId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.batteryMakeId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Battery Make</option>
                          {/* <option value="1">1</option> */}
                          {makeList.map((val) => {
                            // console.log(val.id,"valiadtaion>>>>>>>")
                            return <option value={val.id}>{val.name}</option>;
                          })}
                        </select>
                      </div>
                      <p>{formErrors.batteryMake}</p>
                    </div>
                  </div>

                  <div
                    id="AddSwapStation_Form_row6"
                    className={cn(styles.flex2, styles.flex2_layout)}
                  >
                    <div
                      id="AddSwapStation_BatteryModel_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_BatteryModel"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_BatteryModel_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Battery Model*"}
                        </div>
                        <select
                          id="AddSwapStation_BatteryModel_select"
                          name="batteryModelId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.batteryModelId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Battery Model</option>
                          {/* <option value="1">1</option> */}
                          {modelYearList.map((val) => {
                            return <option value={val.id}>{val.name}</option>;
                          })}
                        </select>
                        {/* <input type="text" name="batteryModel" className={cn(styles.line1, styles.line1_layout)} value={formValues.batteryModel} onChange={handleChange} disabled={onlyView}/> */}
                      </div>
                      <p>{formErrors.batteryModel}</p>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div
                      id="AddSwapStation_SwapStationStatus_block"
                      className={cn(styles.flex2_item)}
                    >
                      <div
                        id="AddSwapStation_SwapStationStatus"
                        className={cn(styles.block3, styles.block3_layout)}
                      >
                        <div
                          id="AddSwapStation_SwapStationStatus_label"
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Swap Station Status*"}
                        </div>
                        <select
                          id="AddSwapStation_SwapStationStatus_select"
                          name="status"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues.status}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Swap Station Status</option>
                          <option value="OFFLINE">Offline</option>
                          <option value="HEALTHY">Healthy</option>
                          <option value="FAULT">Fault</option>
                          <option value="UNDERMAINTENANCE">
                            Under maintenance
                          </option>
                        </select>
                      </div>
                      <p>{formErrors.status}</p>
                    </div>
                  </div>
                  {onlyView && (
                    <div
                      id="AddSwapStation_Form_row7"
                      className={cn(styles.flex2, styles.flex2_layout)}
                    >
                      <div
                        id="AddSwapStation_QRCode_block"
                        className={cn(styles.flex2_item)}
                      >
                        <div
                          id="AddSwapStation_QRCode"
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            id="AddSwapStation_QRCode_layout"
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"QR Code"}
                          </div>
                          <QRCodeView value={id} visibility={true} />
                        </div>
                        {/* <p>{formErrors.batteryModel}</p> */}
                      </div>
                    </div>
                  )}

                  <div
                    id="AddSwapStation_button_container"
                    className={cn(styles.swap_footer_container)}
                  >
                    <div
                      id="AddSwapStation_button_containerView"
                      className={cn(styles.swap_footer_view_container)}
                    >
                      {
                        <div
                          id="AddSwapStation_BackButton"
                          className={cn(
                            action === "view"
                              ? styles.view_footer_btn_back
                              : styles.view_footer_btn
                          )}
                          onClick={routeChange}
                        >
                          <h5
                            id="AddSwapStation_BackButton_title"
                            className={cn(styles.view_footer_btn_heading)}
                          >
                            {action === "view" ? "Back" : "Cancel"}
                          </h5>
                        </div>
                      }
                    </div>
                    <div className={cn(styles.footer_container_spacing)} />
                    {action !== "view" && (
                      <div
                        id="AddSwapStation_submitButton"
                        className={cn(styles.footer_submit_btn_container)}
                        onClick={handleSubmit}
                      >
                        <div
                          id="AddSwapStation_submitButton1"
                          className={cn(styles.footer_submit_btn)}
                        >
                          <h5
                            id="AddSwapStation_submitButton_heading"
                            className={cn(styles.footer_submit_heading)}
                          >
                            {action}
                          </h5>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AddSwapStation(props) {
  return (
    <>
      <Master opts={props} screen={AddSwapStationForm} showStatus={false} />
    </>
  );
}

AddSwapStation.inStorybook = true;
